@if(!loading) {
@if(hasItems || isAwaitingReferences) {
<h4>Next steps</h4>
<p class="introText">If you do one thing today...</p>
<div class="selectable-items-vertical">
    @if(isAwaitingReferences) {
    <div class="selectable-item bold-item todo-button" role="button" (click)="referenceHelp()">
        <img src="/img/icons/todo_icon.png"><span>Awaiting References</span>
    </div>
    }
    @for(item of displayItems; track $index) {
    <div class="selectable-item bold-item todo-button" role="button" (click)="editItem(item)">
        <img src="/img/icons/todo_icon.png"><span>{{item.title}}</span>
    </div>
    }
</div>
} @else {
<h4>Next steps</h4>
<div class="">
    <p>You’re up to date! Keep checking back for your ‘next steps’ on your application!</p>
</div>
}}